import { createAction } from '@reduxjs/toolkit';

import {
  MESSAGES_LIST_RESET,
  MESSAGES_LIST_GET_START,
  MESSAGES_LIST_GET_SUCCESS,
  MESSAGES_LIST_GET_FAILURE,
} from './messagesList.const';

export const messagesListResetAction = createAction(MESSAGES_LIST_RESET);

export const messagesListGetStartAction = createAction(MESSAGES_LIST_GET_START);
export const messagesListGetSuccessAction = createAction(MESSAGES_LIST_GET_SUCCESS);
export const messagesListGetFailureAction = createAction(MESSAGES_LIST_GET_FAILURE);
